import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class StyleControl extends Component {
  static propTypes = {
    active: PropTypes.bool,
    style: PropTypes.string,
    styling: PropTypes.object,
    handler: PropTypes.func.isRequired
  }

  render() {
    const { active, styling, handler } = this.props
    const className = classnames('control', { active })
    return (
      <div
        className={className}
        onMouseDown={handler}
        style={styling}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/style_control.js